import type { ReactNode } from 'react';
import {
  ModerationApprovedIcon,
  ModerationPendingIcon,
  ModerationRejectedIcon,
} from '@noor/ui';
import type { ProductModerationFilter } from '../model/schema';

/**
 * The coloured glyph for each moderation state, from the design's status
 * legend (Figma 1218:5041): orange spinner in review, green check live, red
 * warning sent back. Draft reuses the waiting glyph in a neutral grey tone.
 *
 * One map, used by the sidebar rows, the status selects and the branch cards,
 * so a state cannot wear two different colours on two screens.
 *
 * `size-5` matches the design's 20px badge everywhere except the sidebar's
 * inline pending glyph (16px there), which passes its own size.
 */
export function moderationIcon(
  state: ProductModerationFilter,
  className = 'size-5',
): ReactNode {
  if (state === 'draft') {
    return (
      <ModerationPendingIcon
        className={`${className} [&_path]:stroke-muted-foreground`}
      />
    );
  }
  if (state === 'pending') return <ModerationPendingIcon className={className} />;
  if (state === 'approved') return <ModerationApprovedIcon className={className} />;
  return <ModerationRejectedIcon className={className} />;
}
